import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';

function Analysis() {
  const [status, setStatus] = useState('Analyzing patterns...');
  const navigate = useNavigate();

  useEffect(() => {
    analyzeData();
  }, []);

  const analyzeData = async () => {
    const steps = [
      'Reading your birth numbers...',
      'Building Loshu Grid...',
      'Analyzing patterns...',
      'Generating insights...',
      'Preparing remedies...'
    ];

    for (let i = 0; i < steps.length; i++) {
      await new Promise(resolve => setTimeout(resolve, 800));
      setStatus(steps[i]);
    }

    try {
      const problem = localStorage.getItem('selectedProblem') || 'general';
      
      // Fetch profile from API (not localStorage)
      const profileResponse = await axios.get('/api/profile');
      
      if (!profileResponse.data.exists) {
        setStatus('Profile not found. Please complete your profile.');
        setTimeout(() => navigate('/data-input'), 2000);
        return;
      }
      
      const profile = profileResponse.data.profile;

      const response = await axios.post('/api/numerology/compute', {
        problem: problem,
        input_data: {
          birth_date: profile.birth_date,
          full_name: profile.full_name,
          gender: profile.gender
        }
      });

      localStorage.setItem('analysisResults', JSON.stringify(response.data));
      navigate('/results');
    } catch (err) {
      console.error('Analysis error:', err);
      setStatus('Analysis failed. Please try again.');
      setTimeout(() => navigate('/dashboard'), 2000);
    }
  };

  return (
    <div className="page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        style={{ textAlign: 'center', maxWidth: '500px' }}
      >
        <motion.div
          animate={{
            rotate: 360,
            scale: [1, 1.1, 1]
          }}
          transition={{
            rotate: { duration: 2, repeat: Infinity, ease: 'linear' },
            scale: { duration: 1, repeat: Infinity }
          }}
          style={{
            width: '120px',
            height: '120px',
            margin: '0 auto 2rem',
            background: 'linear-gradient(135deg, #00D9FF 0%, #0891B2 100%)',
            borderRadius: '24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '3rem'
          }}
        >
          ✨
        </motion.div>
        <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>
          {status}
        </h2>
        <p style={{ color: '#9CA3AF' }}>
          Decoding your energy patterns...
        </p>
      </motion.div>
    </div>
  );
}

export default Analysis;